import API from "./api";
import { Contact_API_URLS } from "./constants";
export function contactUsApi(args) {
    return API.post(Contact_API_URLS.contactUsUrl,args);
  }
